<template>
  <b-container fluid class="p-0">
    <b-card class="mx-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          Criar Aviso
          <btn-voltar />
        </h6>
      </template>
      <b-tabs card fill>
        <b-tab title="Dados gerais do aviso" active>
          <div id="tabDadosGerais">
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form @submit.stop.prevent="handleSubmit(salvarDadosGerais)">
                <b-row>
                  <b-col cols="12">
                    <default-form-validation-provider label="Título" v-slot="defaultState">
                      <b-form-input id="input-titulo" v-model="aviso.Titulo" :state="defaultState.state" type="text"
                        maxlength="100" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" class="mb-3">
                    <span class="d-block text-left pb-1">Mensagem</span>
                    <div id="mensagemWrapper" :class="validarInputMensagem()">
                      <rich-text-editor @update-value="atualizarMensagem" :initial-content="aviso.Mensagem" />
                    </div>
                  </b-col>
                  <b-col cols="12" lg="6" xl="4">
                    <default-form-validation-provider label="Protocolo / Processo vinculado" rules=""
                      v-slot="defaultState">
                      <b-form-input id="input-protproc" v-model="aviso.Protocolo" :state="defaultState.state"
                        type="text" maxlength="14" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6" xl="4">
                    <default-form-validation-provider label="Departamento de Origem" rules="">
                      <multiselect v-model="aviso.Departamento" open-direction="bottom" :close-on-select="true"
                        :searchable="true" deselect-label="" :allow-empty="true" placeholder="Selecione um depto"
                        track-by="Id" :options="departamentos" label="Nome" :show-labels="false"
                        class="wrapper-multiselect-sagres">
                        <template slot="noOptions">
                          <small><i>Erro ao obter dados.</i></small>
                        </template>
                        <template slot="noResult">
                          <i>Sem resultados.</i>
                        </template>
                      </multiselect>
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" lg="6" xl="4">
                    <default-form-validation-provider label="Data de Validade" v-slot="defaultState">
                      <b-form-datepicker id="input-dataValidade" :state="defaultState.state"
                        v-model="aviso.DataValidade" v-bind="datePickerProps" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <default-form-validation-provider rules="" label="Permite Resposta?">
                      <b-form-checkbox id="checkbox-1" v-model="aviso.PermiteResposta" name="input-permiteResposta" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" xl="4" class="d-flex flex-row-reverse align-items-center">
                    <b-button size="sm" type="submit">
                      <font-awesome-icon icon="save" class="mr-2" />
                      Salvar alterações
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
        </b-tab>
        <b-tab title="Anexos">
          <b-alert v-if="idAviso == null" :show="idAviso == null" variant="warning">
            Salve os dados gerais para adicionar anexos ao aviso.
          </b-alert>
          <div v-else id="tabAnexos">
            <b-button class="float-right mb-3" @click="mostrarModalAnexos = true">
              <font-awesome-icon icon="plus" class="mr-2" />
              Adicionar Anexo
            </b-button>
            <b-table :busy="isBusy" :fields="anexosFields" hover no-border-collapse :items="anexos" :sort-desc="true"
              striped small show-empty :per-page="anexosPerPage" :current-page="anexosCurrentPage">
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="actions-icons">
                  <btn-download-component :fazerDownload="baixarAnexo" :parametros="row.item" />
                  <div class="wrapper-icon" @click="abrirModalExclusaoAnexo(row.item)">
                    <font-awesome-icon icon="trash" />
                    <div style="font-size: 12px">Remover</div>
                  </div>
                </div>
              </template>
            </b-table>
            <table-pagination :total-rows="anexos.length" :per-page="anexosPerPage" @pageChange="anexosPageChange">
            </table-pagination>
          </div>
        </b-tab>
        <b-tab title="Destinatários">
          <b-alert v-if="idAviso == null" :show="idAviso == null" variant="warning">Salve os dados gerais para adicionar
            destinatários ao
            aviso.</b-alert>
          <div v-else id="tabDestinatarios">
            <b-button class="float-right mb-4" @click="mostrarModalDestinatarios = true">
              <font-awesome-icon icon="plus" class="mr-2" />
              Adicionar Destinatários
            </b-button>
            <b-table :busy="isBusy" :fields="destinatariosFields" hover no-border-collapse :items="destinatarios"
              :sort-desc="true" striped small show-empty :per-page="destinatariosPerPage"
              :current-page="destinatariosCurrentPage">
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="actions-icons">
                  <div class="wrapper-icon" @click="abrirModalExclusaoDestinatario(row.item)">
                    <font-awesome-icon icon="trash" />
                    <div style="font-size: 12px">Remover</div>
                  </div>
                </div>
              </template>
            </b-table>
            <table-pagination :total-rows="destinatarios.length" :per-page="destinatariosPerPage"
              @pageChange="destinatariosPageChange"></table-pagination>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal v-if="deleteDestinatario" id="confirm-delete-destinatario-modal" size="sm" button-size="sm" centered
      header-bg-variant="secondary" header-text-variant="light" header-class="" footer-class="" modal-class="p-2"
      no-close-on-backdrop no-close-on-esc>
      <template v-slot:modal-header="">
        <h5>Confirmar remoção</h5>
      </template>
      Tem certeza que deseja remover o destinatário?
      <template v-slot:modal-footer="">
        <b-button size="sm" @click="removerDestinatario()"> Excluir </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalExclusaoDestinatario()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
    <b-modal v-if="deleteAnexo" id="confirm-delete-anexo-modal" size="sm" button-size="sm" centered
      header-bg-variant="secondary" header-text-variant="light" header-class="" footer-class="" modal-class="p-2"
      no-close-on-backdrop no-close-on-esc>
      <template v-slot:modal-header="">
        <h5>Confirmar remoção</h5>
      </template>
      Tem certeza que deseja remover o anexo {{ deleteAnexo.Nome }}?
      <template v-slot:modal-footer="">
        <b-button size="sm" @click="removerAnexo()"> Excluir </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalExclusaoAnexo()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
    <modal-selecionar-destinatarios v-if="mostrarModalDestinatarios"
      @fecharModalDestinatarios="mostrarModalDestinatarios = false" />
    <modal-adicionar-anexo v-if="mostrarModalAnexos" @fecharModalAdicionarAnexo="fecharModalAdicionarAnexos()" />
  </b-container>
</template>

<script lang="ts">
import { store } from "@/store";
import messagesService from "@/services/messagesService";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import RichTextEditor from "@/components/RichTextEditor.vue";
import ModalSelecionarDestinatarios from "./ModalSelecionarDestinatarios.vue";
import ModalAdicionarAnexo from "./ModalAdicionarAnexo.vue";
import BtnDownloadComponent from "@/components/shared/btn-download.vue";
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import { UtilsTS } from '@/utilsts';
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import { DatePickerDefaultProps } from '@/types/form-default-props'
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Aviso } from "@/types/avisos/aviso";
import { fieldsDestinatarios } from "@/types/avisos/fields-destinatarios";
import { fieldsAnexos } from "@/types/avisos/fields-anexos";
import { PortalError } from "@/types/portal-error";
import { ValidationObserver } from "vee-validate"
import Multiselect from "vue-multiselect";
import { DepartamentoResumido } from "@/types/administracao/departamento-resumido";

const CompProps = Vue.extend({
  name: 'CriarAviso',
  components: {
    BtnDownloadComponent,
    BtnVoltar,
    DefaultFormValidationProvider,
    ModalAdicionarAnexo,
    ModalSelecionarDestinatarios,
    Multiselect,
    RichTextEditor,
    TablePagination,
    ValidationObserver,
  },
})
@Component
export default class CriarAviso extends mixins(UtilsTS, CompProps) {
  datePickerProps = DatePickerDefaultProps

  mostrarModalDestinatarios = false
  mostrarModalAnexos = false
  idAviso: number | null = null
  aviso: Aviso = new Aviso()
  destinatarios: any[] = []
  departamentos: DepartamentoResumido[] = []
  anexos: any[] = []
  isBusy = true
  destinatariosFields = fieldsDestinatarios
  destinatariosPerPage = 10
  destinatariosCurrentPage = 1

  anexosFields = fieldsAnexos
  anexosPerPage = 10
  anexosCurrentPage = 1

  inputMensagemMudou = false

  deleteDestinatario: any = null
  deleteAnexo: any = null

  abrirModalExclusaoDestinatario(item) {
    this.deleteDestinatario = item;
    this.$bvModal.show("confirm-delete-destinatario-modal");
  }
  fecharModalExclusaoDestinatario() {
    this.deleteDestinatario = null;
    this.$bvModal.hide("confirm-delete-destinatario-modal");
  }

  abrirModalExclusaoAnexo(item) {
    this.deleteAnexo = item;
    this.$bvModal.show("confirm-delete-anexo-modal");
  }
  fecharModalExclusaoAnexo() {
    this.deleteAnexo = null;
    this.$bvModal.hide("confirm-delete-anexo-modal");
  }

  async fecharModalAdicionarAnexos() {
    this.mostrarModalAnexos = false;
    await this.getAnexos(this.idAviso);
  }

  atualizarMensagem(value) {
    this.aviso.Mensagem = value;
    this.inputMensagemMudou = true;
  }
  getValidationState({ dirty, validated, valid = null }) {
    return dirty || validated ? valid : null;
  }
  destinatariosPageChange(value) {
    this.destinatariosCurrentPage = value;
  }
  anexosPageChange(value) {
    this.anexosCurrentPage = value;
  }
  async getAviso(id: number): Promise<void> {
    try {
      this.isBusy = true;
      const avisoResponse = await messagesService.getAviso(id);
      this.aviso = avisoResponse.aviso
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      this.isBusy = false;
    }
  }

  async getDestinatarios(id) {
    this.isBusy = true;

    const response = await messagesService.getDestinatarios(id);
    if (response && response.status == 200) {
      this.destinatarios = response.data.destinatarios;
    } else {
      this.$toast.error("Erro ao obter lista de destinatários");
    }

    this.isBusy = false;
  }

  async getAnexos(id) {
    this.isBusy = true;

    const response = await messagesService.getAnexosAviso(id);
    if (response && response.status == 200) {
      this.anexos = response.data;
    } else {
      this.$toast.error("Erro ao obter anexos");
    }
    this.isBusy = false;
  }

  async baixarAnexo(arquivo) {
    const response = await messagesService.baixarAnexo(arquivo.Id);
    if (response && response.status == 200)
      this.download(arquivo.Nome, response.data);
    else {
      this.$toast.error("Erro ao baixar o arquivo solicitado.");
    }
  }

  async removerAnexo() {
    const response = await messagesService.removerAnexo(this.deleteAnexo.Id);
    if (response && response.status == 200) {
      await this.getAnexos(this.idAviso);
      this.$toast.success("Anexo removido com sucesso.");
    } else {
      this.$toast.error("Erro ao remover o arquivo solicitado.");
    }

    this.fecharModalExclusaoAnexo();
  }

  validarInputMensagem() {
    if (!this.inputMensagemMudou) return "";

    if ((this.inputMensagemMudou &&
      (this.aviso.Mensagem == null ||
        this.aviso.Mensagem == "" ||
        this.aviso.Mensagem == " "))
    ) {
      return "invalid";
    }

    if (
      (this.inputMensagemMudou &&
        (this.aviso.Mensagem != null ||
          this.aviso.Mensagem != "" ||
          this.aviso.Mensagem != " ")) ||
      this.aviso.Mensagem != null ||
      this.aviso.Mensagem != "" ||
      this.aviso.Mensagem != " "
    ) {
      return "valid";
    }
  }

  async removerDestinatario() {
    const response = await messagesService.removerDestinatario(
      this.deleteDestinatario.idDestinatario
    );
    if (response && response.status == 200 && this.idAviso) {
      const responseDestinatarios = await messagesService.getDestinatarios(
        this.idAviso
      );
      this.destinatarios = responseDestinatarios.data.destinatarios;
      this.$toast.success("Destinatario removido com sucesso");
    } else if (response && response.data.msg && response.status == 400) {
      this.$toast.error(response.data.msg)
    } else {
      this.$toast.error("Não foi possível remover o destinatário");
    }

    this.deleteDestinatario = null;
    this.$bvModal.hide("confirm-delete-modal");
  }

  async salvarDadosGerais() {
    // a validação do conteúdo em rich text é manual, não envolve vee-validate.
    if (!this.aviso.Mensagem || this.aviso.Mensagem.length == 0) {
      this.$toast.error("Preencha a mensagem do aviso")
      return
    }
    if (this.aviso.Departamento !== null) this.aviso.IdDepartamento = this.aviso.Departamento?.Id

    const response = await messagesService.criarAviso(this.aviso);

    if (response && response.status === 200) {
      this.$toast.success("Aviso criado com sucesso");
      this.$router.push("/avisos/editar/" + response.data.Id);
    } else {
      this.$toast.error(response.data.msg || "Erro ao criar o aviso");
    }
  }

  async mounted() {
    this.aviso.UsuarioCadastro = store.nomeUsuario;
    this.departamentos = await messagesService.getDepartamentosOrigemAvisos();
  }
}
</script>

<style>
#mensagemWrapper {
  width: 100% !important;
}

#mensagemWrapper.invalid .tox-tinymce {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

#mensagemWrapper.valid .tox-tinymce {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

#mensagemWrapper label {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>